import type { AppProps } from "next/app";
import "../globals.scss";
import { StandardProps } from "@/components/componentMap";

export default function App({ Component, pageProps }: AppProps<StandardProps>) {
  return <Component {...pageProps} />;
}
